import * as React from 'react';
import { Button, FormControl, TextField, MenuItem } from '@material-ui/core';
//import Autocomplete from '@material-ui/lab/Autocomplete';
import { withStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import { PlayersList } from './playersList';
import { playersActions } from "../../common/players/actionsReducers";
import { ageGroupActions } from "../../common/ageGroupActionsReducers";
import { ConnectedComponent } from "../ConnectedComponent";
const styles = (theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: 200,
        },
    },
    button: {
        margin: theme.spacing(1),
    }
});
const { propsGeneric, connect } = new ConnectedComponent().mapToProps((state) => ({
    players: state.players.players,
    isSearching: state.isSearching, isLoading: state.players.isLoading,
    ageGroups: state.ageGroups
}), (dispatch) => ({
    searchPlayers: (name, clubName, playerId, gender, ageGroupId, matchDate) => dispatch(playersActions.searchPlayers(name, clubName, playerId, gender, ageGroupId, matchDate)),
    getAgeGroups: () => dispatch(ageGroupActions.getAll())
}));
class SearchPlayers extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = (e) => {
            e.preventDefault();
            const input = this.state.searchForm;
            console.log(this.state.searchForm);
            this.setState({ players: { isLoading: true } });
            this.props.searchPlayers(input.playerName, input.playerClub, input.playerId, input.playerGender, input.playerAgeGroup, new Date(this.props.matchData.roundDate)).then(() => {
                this.setState({ players: { isLoading: false } });
            });
        };
        this.state = {
            searchForm: {},
            players: { isLoading: false }
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.selectedPlayer = this.selectedPlayer.bind(this);
    }
    componentDidMount() {
        this.props.getAgeGroups();
    }
    selectedPlayer(player) {
        this.props.selectedPlayer(player);
    }
    inputChangeHandler(e) {
        const [key, value] = [e.target.name, e.target.value];
        this.setState((prevState) => {
            return {
                searchForm: Object.assign(Object.assign({}, prevState.searchForm), { [key]: value })
            };
        });
    }
    render() {
        const { classes } = this.props;
        if (this.props.ageGroups.isLoading) {
            return null;
        }
        const ageGroups = this.props.ageGroups.ageGroups;
        return (React.createElement("div", null,
            React.createElement("form", { onSubmit: this.handleSubmit },
                React.createElement(FormControl, { className: classes.root },
                    React.createElement("div", null,
                        React.createElement(TextField, { name: "playerName", label: "Navn", helperText: "Kan v\u00E6re helt eller delvist udfyldt", onChange: this.inputChangeHandler }),
                        React.createElement(TextField, { name: "playerClub", label: "Klub", helperText: "Kan v\u00E6re helt eller delvist udfyldt", onChange: this.inputChangeHandler }),
                        React.createElement(TextField, { name: "playerId", label: "Badminton ID", onChange: this.inputChangeHandler })),
                    React.createElement("div", null,
                        React.createElement(TextField, { name: "playerGender", label: "K\u00F8n", onChange: this.inputChangeHandler, select: true }, [{ value: '', label: '' }, { value: 'M', label: 'Mand' }, { value: 'K', label: 'Kvinde' }].map((option) => (React.createElement(MenuItem, { key: option.value, value: option.value }, option.label)))),
                        React.createElement(TextField, { name: "playerAgeGroup", label: "\u00C5rgang", onChange: this.inputChangeHandler, select: true }, ageGroups.map((ageGroup) => (React.createElement(MenuItem, { key: ageGroup.ageGroupId, value: ageGroup.ageGroupId }, ageGroup.ageGroupName))))),
                    React.createElement("div", null,
                        React.createElement(Button, { variant: "contained", color: "default", className: classes.button, endIcon: React.createElement(SearchIcon, null), type: "submit" }, "S\u00F8g")))),
            React.createElement(PlayersList, { players: this.props.players, isLoading: this.state.players.isLoading, selectedPlayer: this.selectedPlayer })));
    }
}
export default withStyles(styles, { withTheme: true })(connect(SearchPlayers));
